module.exports = __webpack_public_path__ + "3e99c23db43a3000d9c4d7cf277a0450.svg";